import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrClosing } from '../../../../../../../shared/types/modules/pqr';

export const usePqrObservationClose = (closing?: PqrClosing) => {
    const formik = useFormik({
        initialValues: {
            observation: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            observation: closing?.observation || '',
        });
    }, [closing]);

    return {
        formik,
    };
};
